import React, { useState, useEffect } from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import { FaTooth, FaEdit } from "react-icons/fa";
import { Button, Input } from "../../components/Form";
import Modal from "../../components/Modals/Modal";
import { FaSave } from "react-icons/fa";
import { useAppSelector } from '../../store';

import { viewLabProductExtra, editLabProductExtra } from "../../api/labProductExtra";
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import Loader from "../../components/Loader";

function SingleExtra() {
	const userData = useAppSelector((state) => state.userData);

	const [modal, setModal] = useState(false);
	const [productExtra, setProductExtra] = useState([]);
	const [name, setName] = useState("");
	const [price, setPrice] = useState("");
	const [pageLoader, setPageLoader] = useState(true);
	const [loading, setLoading] = useState(false);
	const { id } = useParams();

	useEffect(() => {
		console.log(userData)
		const fetchData = async () => {
			const res = await viewLabProductExtra({ productExtraId: id });
			setProductExtra(res);
			setName(res?.name);
			setPrice(res?.price);
			setPageLoader(false);
			console.log(res);
		};

		if (userData?.user?.defaultLabId) {
			fetchData();
		}
	}, [userData, modal]);

	const handleSave = async () => {
		if (!name.trim()) {
			toast.error("Name is required");
			return;
		}

		const data = {
			productExtraId: productExtra?._id,
			name: name,
			price: price || 0,
		};

		setLoading(true);
		const response = await editLabProductExtra(data);
		if (response) {
			setLoading(false);
			setModal(false);
			setName("");
			setPrice("");
		}
	}

	return (
		<Layout>
			{
				pageLoader ? <Loader /> :
					<Container className="flex flex-col min-w-80 max-w-80 px-5 py-10 items-center bg-white/60 rounded-lg">
						<FaTooth size={44} className="text-gray-900/85" />
						<div className="text-lg my-1">{productExtra?.name}</div>
						<div className="text-xs mt-1">price:</div>
						<div className="text-xs mb-4">{productExtra?.price ?? 0} BAM</div>
						<Button
							className="flex max-w-fit px-4 items-center"
							Icon={() => <FaEdit size={16} />}
							label={"Edit"}
							onClick={() => setModal(true)}
						/>
						<Modal isOpen={modal} closeModal={() => setModal(false)} title={"Edit Product Extra"}>
							<Input label={"Name *"} placeholder={"Metal ceramic, Zirconia, ..."} color={true} value={name} onChange={(e) => setName(e.target.value)} />
							<Input label={"Price (BAM)"} placeholder={"Price"} color={true} type={"number"} min={0} value={price} onChange={(e) => setPrice(e.target.value)} />
							<Button className={"my-4"} label={"Save"} Icon={FaSave} onClick={handleSave} loading={loading} />
						</Modal>
					</Container>
			}
		</Layout>
	);
}

export default SingleExtra;
